const HASHNODE_API = 'https://gql.hashnode.com'
const PUBLICATION_HOST = 'prashamtated.hashnode.dev'

export async function fetchBlogPosts(first = 20) {
  const query = `
    query GetPosts($host: String!, $first: Int!) {
      publication(host: $host) {
        posts(first: $first) {
          edges {
            node {
              id
              title
              slug
              brief
              publishedAt
              coverImage { url }
            }
          }
        }
      }
    }
  `

  const res = await fetch(HASHNODE_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      query,
      variables: { host: PUBLICATION_HOST, first }
    })
  })

  if (!res.ok) throw new Error(`Hashnode API error: ${res.status}`)

  const { data, errors } = await res.json()
  if (errors) throw new Error(errors[0].message)
  if (!data.publication) throw new Error('Publication not found — check PUBLICATION_HOST in services/hashnode.js')

  return data.publication.posts.edges.map(({ node }) => {
    const date = new Date(node.publishedAt)
    return {
      id: node.id,
      slug: node.slug,
      title: node.title,
      excerpt: node.brief,
      image: node.coverImage?.url || '',
      alt: node.title,
      day: String(date.getDate()),
      month: date.toLocaleString('en', { month: 'short' })
    }
  })
}

export async function fetchBlogPost(slug) {
  const query = `
    query GetPost($host: String!, $slug: String!) {
      publication(host: $host) {
        post(slug: $slug) {
          id
          title
          slug
          brief
          publishedAt
          coverImage { url }
          content { html }
          tags { name }
        }
      }
    }
  `

  const res = await fetch(HASHNODE_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      query,
      variables: { host: PUBLICATION_HOST, slug }
    })
  })

  if (!res.ok) throw new Error(`Hashnode API error: ${res.status}`)

  const { data, errors } = await res.json()
  if (errors) throw new Error(errors[0].message)

  const post = data.publication?.post
  if (!post) return null

  const date = new Date(post.publishedAt)
  return {
    id: post.id,
    slug: post.slug,
    title: post.title,
    excerpt: post.brief,
    image: post.coverImage?.url || '',
    alt: post.title,
    day: String(date.getDate()),
    month: date.toLocaleString('en', { month: 'short' }),
    content: post.content.html,
    tags: post.tags?.map(t => t.name) || []
  }
}
